import { React, ui } from "./common";

// The URL comes from Hosting:DashboardBaseUrl, but changing that restarts the web app. To turn the
// redirect off mid-day, set "disableDashboardRedirect": true in wwwroot/config.json instead.
// Anything going wrong here leaves the user on this dashboard.
async function getRedirectTarget(): Promise<URL | null> {
    try {
        // no-store because browsers would otherwise reuse a cached copy, and the off switch wouldn't reach them
        const config = await (await fetch("./config.json", { cache: "no-store" })).json();
        if (config.disableDashboardRedirect === true) return null;

        const response = await fetch(`${config.apiUrl || ""}/public/dashboard-url`, { headers: { Accept: "application/json" } });
        if (!response.ok) return null;

        const { dashboardUrl } = await response.json();
        const target = new URL(dashboardUrl);
        return target.host === window.location.host ? null : target;
    } catch (err) {
        console.log("Unable to check for the dashboard redirect", err);
        return null;
    }
}

function redirect(target: URL) {
    // Keep the hash so bookmarks and emailed links land on the same page. replace() so the back
    // button doesn't come straight back here and redirect again.
    target.hash = window.location.hash;
    window.location.replace(target.href);
}

export default function DashboardRedirect(props: { children: any }) {
    const [checked, setChecked] = React.useState(false);

    React.useEffect(() => {
        getRedirectTarget().then(url => {
            // The spinner stays up while the browser leaves for the new dashboard
            if (url) {
                redirect(url);
            } else {
                setChecked(true);
            }
        });
    }, []);

    if (!checked) {
        return <div style={{ textAlign: "center", marginTop: 200 }}><ui.Spin size="large" /></div>;
    }

    return props.children;
}
